import { DateTime } from 'luxon';
import { FetchRewardExperienceResponse } from '../services/reward.experience.service';

const LEADING_SITE_NAME_PREFIX = /^\[site name\]\s*-\s*/iu;
const SITE_NAME_PLACEHOLDER = /\[site name\]/giu;

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/gu, '\\$&');

const messageWithoutLeadingSite = (title: string, siteName: string): string => {
  const withoutPlaceholder = title.replace(LEADING_SITE_NAME_PREFIX, '').trim();

  if (siteName === '') {
    return withoutPlaceholder;
  }

  const resolvedSitePrefix = new RegExp(`^${escapeRegExp(siteName)}\\s*-\\s*`, 'iu');
  return withoutPlaceholder.replace(resolvedSitePrefix, '').trim();
};

const errorTitleWithSiteName = (rewardExperience: FetchRewardExperienceResponse | null): string => {
  const siteName = rewardExperience?.site?.name?.trim() ?? '';
  const errorTitle = rewardExperience?.rewardConfiguration?.errors?.params?.title?.trim() ?? '';

  if (siteName === '' || errorTitle === '') {
    return errorTitle;
  }

  return errorTitle.replace(SITE_NAME_PLACEHOLDER, siteName);
};

export const resolveBrowserTitle = (rewardExperience: FetchRewardExperienceResponse | null, isAvailable: boolean, fillLimitDate: string | null): string => {
  if (rewardExperience === null || rewardExperience.experience === undefined) {
    return errorTitleWithSiteName(rewardExperience);
  }

  const siteName = rewardExperience.site.name.trim();
  const { params } = rewardExperience.rewardConfiguration.payment;
  const prefixTitle = params.prefixTitle.trim();
  const paymentMessage = messageWithoutLeadingSite(params.title, siteName);
  const successMessage = messageWithoutLeadingSite(params.successTitle, siteName) || paymentMessage;
  const withSitePrefix = (message: string): string => `${prefixTitle} ${siteName} - ${message.trim()}`;

  if (isAvailable === false) {
    return withSitePrefix(rewardExperience.rewardConfiguration.errors.canceled.subtitle);
  }

  const isExpired = fillLimitDate !== null && DateTime.now() > DateTime.fromISO(fillLimitDate);

  if (isExpired) {
    return withSitePrefix(rewardExperience.rewardConfiguration.errors.expired.subtitle);
  }

  return withSitePrefix(successMessage);
};
